(function(args) { 

	let terms = [];

	if (args.terms) {
		terms = Object.entries(args.terms).map(([id, value]) => {					                		

			var audience_current = jQuery('#form_publications_field_audience').val(); 
			return `<option value="${id}" ${id == audience_current ? 'selected="selected"' : ''}>${value}</option>`;
		});
	}

	document.getElementById(args.id).innerHTML = `
		<div class="form-field search-filter publications-search-filter search-filter-select publications-search-filter-audience">
	        <select>
				<option value="" selected disabled hidden>Audience</option>
	            <option value="0">All</option>
	            ${terms}
	        </select>
	        <span class="input-span">
	        	<span class="icons-svg icons-svg-caret-bottom"></span>
	        </span>		
		</div>
	`;
	document.addEventListener('DOMContentLoaded', function() { 
		document.addEventListener('change', function(e) {
			if (e.target.matches('.publications-search-filter.publications-search-filter-audience select')) { 
				document.getElementById('form_publications_field_audience').value = e.target.value;
			} 
		});
	});

})(args);